import React from 'react'
import { useNotification } from '@fortressiq/fiq-ds'

export default Component => props => {
  const { addNotification } = useNotification()

  return <Component addNotification={addNotification} {...props} />
}
